import React, { useLayoutEffect, useState, useEffect, useRef } from 'react';
import { View, StyleSheet, ActivityIndicator, Image, ScrollView } from 'react-native';
import BottomSheet from 'react-native-simple-bottom-sheet';
import { Color, CommonStyles } from '../styles';
import HeaderTitle from '../components/shared/HeaderTitle';
import { rightAgentHeaderOption } from '../utils/defaultNavOptions';
import BottomButton from '../components/BottomButton';
import Trips from '../components/TripHub/Trips';
import JoinTrip from '../components/TripHub/JoinTrip';
import Event from '../components/TripHub/Event';
import Group from '../components/TripHub/Group';
import { useSelector, useDispatch } from 'react-redux';
import BaseText from '../components/BaseText';
import FloatButton from '../components/FloatButton';
import ChatInput from '../components/TripHub/Chat/ChatInput';
import { Modals, Screens } from '../constants/ScreenNames';
import WrapBottomColor from '../components/containers/WrapBottomColor';
import InvoiceSummary from '../components/TripInvoice/InvoiceSummary';
import { getTripConfirmation } from '../store/actions/payment';
import { selectFirstReceipt, selectTripSelected } from '../store/selectors/mytrips.selector';
import { scale } from '../utils/scale.utils';
import useAvailableHeight from '../utils/useAvailableHeight';
import EventModal from '../components/TripHub/Event/EventModal';
import { userTypes, triphubTabs as tabs, labelByUsers, ComponentChars } from '../constants/Enums';
import { useTranslation } from 'react-i18next';
import i18n, { useComponentTKey, i18nNS } from '../i18n';
import { useDateFormat } from '../utils/useDateFormat';
import { selectAllTripEvents } from '../store/selectors/events.selector';
import CircleSegmentedControl from '../components/SegmentedControl/CircleSegmentedControl';
import { setSelectedEvent } from '../store/actions/events';
import { exportToCalendar } from '../utils/calendar.utils';
import { isExpenseAllowed } from '../store/selectors/profile.selector';
import { changeCdnUrl } from '../utils/common.utils';
import { getLastDutyOfCareByTripKey } from '../store/actions/mytrips';
import { LinearGradient } from 'expo-linear-gradient';
import TripName from '../components/TripHub/TripName';
import { CREW_ENABLED } from '../config/env';

import { useBackButtonEffect } from '../utils/useBackButtonEffect';

const schedule = [
  {
    day: 'Mon, Jun 20',
    activities: [
      '9:15A AA DFW - 11:15A AA MIA',
      '11:15A Pick Up at Budget Rental',
      '12:00P Lunch Meeting New Clients and make request for documentation',
      '2:00P Walk Through Expectations',
      '4:00P Hotel Check In',
    ],
  },
  {
    day: 'Thu, Jun 23',
    activities: [
      'GBTA Conference',
      '11:00A Hotel Check Out',
      '11:15A Drop Off at Budget Rental',
      '10:15A AA MIA - 12:15P AA DFW',
      'meeting ITS',
    ],
  },
  {
    day: 'Thu, Jun 24',
    activities: ['Trip Ends'],
  },
];

const { HOTEL } = ComponentChars;

const isOnlyHotel = (Tripcomponents) => {
  return Tripcomponents === HOTEL;
};

const getOptions = (withGroup) => {
  const options = [{ label: i18n.t('tripHub:TripHubScreen.trip'), icon: 'bag', value: tabs.TRIP }];

  if (!CREW_ENABLED) {
    options.push({
      label: i18n.t('tripHub:TripHubScreen.event'),
      icon: 'event',
      value: tabs.EVENT,
    });
    if (withGroup) {
      options.push({
        label: i18n.t('tripHub:TripHubScreen.group'),
        icon: 'people',
        value: tabs.GROUP,
      });
    }
  }

  return options;
};

const TripHubContent = ({ selectedTab, userType, groupUsers, data }) => {
  switch (selectedTab) {
    case tabs.TRIP:
      if (userTypes.VISITOR === userType) {
        return <JoinTrip />;
      } else {
        return <Trips userType={userType} />;
      }
    case tabs.EVENT:
      return <Event userType={userType} />;
    case tabs.GROUP:
      return <Group disable data={data} users={groupUsers} userType={userType} />;
    default:
      break;
  }
};

const floatIconMap = {
  [tabs.TRIP]: 'plusWithBag',
  [tabs.EVENT]: 'plusWithCalendar',
  [tabs.GROUP]: 'plusWithPerson',
  expense: 'plusWithClip',
};

const getFloatIcon = (selectedTab, isInvoiceEnabled, enabledExpense) => {
  if (selectedTab === tabs.EVENT || selectedTab === tabs.GROUP) {
    return floatIconMap[selectedTab];
  }

  if (selectedTab === tabs.TRIP) {
    return isInvoiceEnabled && enabledExpense ? floatIconMap.expense : floatIconMap[tabs.TRIP];
  }
};

// INFO: the component doesnt support an instance of Stylesheet
const bottomWrapperStyle = {
  backgroundColor: 'transparent',
  paddingHorizontal: 0,
  elevation: 0,
};
const bottomSheetLineStyle = {
  padding: 0,
  marginTop: 12,
  marginBottom: 12,
};

const TripHubScreen = ({ navigation, route }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(route?.params?.initialTab || tabs.TRIP);
  const [loading, setLoading] = useState(false);
  const receiptResponse = useSelector(selectFirstReceipt);
  const [type, setType] = useState(userTypes.OWNER);
  const [showEventModal, setShowEventModal] = useState(false);
  const [showInvoice, setShowInvoice] = useState(route?.params?.showInvoiceFirst);
  const availableHeight = useAvailableHeight(scale(30));
  const tripEvents = useSelector(selectAllTripEvents);
  const isExpenseEnabled = useSelector(isExpenseAllowed);
  const tripSelected = useSelector(selectTripSelected);
  const [data, setData] = useState(
    null
    //[
    // {
    //   id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
    //   title: 'First Item',
    // },
    // {
    //   id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
    //   title: 'Second Item',
    //   self: true,
    // },
    //]
  );
  const options = getOptions(true, tripSelected.Tripcomponents);
  const groupUsers = [];
  const formatDate = useDateFormat();
  const invoicePanelRef = useRef(null);
  const floatIcon = getFloatIcon(selectedTab, showInvoice, isExpenseEnabled);

  //Back button effect to trips screen
  useBackButtonEffect(navigation, Screens.MyTrips, {
    fromFilterOrTripHubScreen: true,
  });

  const getDate = (date) => {
    if (date) {
      const [month, day, year] = date.split(' ');
      return formatDate(new Date(`${month} ${day}, ${year}`)) + ' ' + year;
    }
    return '';
  };

  const fromDate = getDate(receiptResponse?.FromDate);
  const toDate = getDate(receiptResponse?.ToDate);

  useEffect(() => {
    if (
      userTypes.GUEST === route.params?.userType ||
      userTypes.VISITOR === route.params?.userType
    ) {
      setType(route.params?.userType);
    }
    if (userTypes.VISITOR === route.params?.userType) {
      setShowEventModal(true);
    }
  }, [route.params]);

  useEffect(() => {
    async function fetchrePrice() {
      setLoading(true);
      if (route.params.tripKey) {
        await dispatch(getTripConfirmation(route.params.tripKey, route.params?.travelRequestId));
        await dispatch(getLastDutyOfCareByTripKey(route.params.tripKey));
      } else {
        await dispatch(getTripConfirmation());
      }
      setLoading(false);
    }
    fetchrePrice();
  }, [dispatch, route.params.tripKey]);

  const getTripTitle = () => {
    if (receiptResponse) {
      const { FriendlyName, FromCity } = receiptResponse;
      if (FriendlyName && FromCity) {
        return `${FriendlyName}, ${FromCity}`;
      }
      if (FriendlyName || FromCity) {
        return FriendlyName || FromCity;
      }
    }
    return Screens.TripHub;
  };

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => (
        <HeaderTitle
          title={getTripTitle()}
          subtitle={
            receiptResponse?.FromDate
              ? `${formatDate(receiptResponse?.FromDate, 'LL')} ${
                  toDate ? '- ' + formatDate(receiptResponse?.ToDate, 'LL') : ''
                }`
              : ''
          }
        />
      ),
      ...rightAgentHeaderOption({ navigation }),
    });
  }, [navigation, receiptResponse, fromDate, toDate, t, tKey, formatDate]);

  const onSubmit = () => {
    switch (selectedTab) {
      case tabs.TRIP:
        if (invoicePanelRef.current) {
          invoicePanelRef.current.togglePanel();
        }
        break;
      case tabs.EVENT:
        dispatch(setSelectedEvent(null));
        navigation.navigate(Modals.MeetingFormModal, { trip: receiptResponse });
        break;
      case tabs.GROUP:
        navigation.navigate(Modals.InviteTravelerModal);
        break;
    }
  };

  const onClickFloat = () => {
    switch (selectedTab) {
      case tabs.TRIP:
        break;
      case tabs.EVENT:
        exportToCalendar(tripEvents);
        break;
      case tabs.GROUP:
        navigation.navigate(Modals.InviteTravelerModal);
        break;
    }
  };

  const chooseEventOption = (optionNumber) => {
    switch (optionNumber) {
      case 0:
        setShowEventModal(false);
        break;
      case 1:
        setShowEventModal(false);
        break;
    }
  };

  if (loading) {
    return (
      <View style={[CommonStyles.flex1, CommonStyles.centerItems, CommonStyles.centerAlignment]}>
        <ActivityIndicator color={Color.primary} />
      </View>
    );
  }

  if (!receiptResponse) {
    return (
      <View>
        <BaseText>There is no information to show</BaseText>
      </View>
    );
  }

  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <EventModal data={schedule} visible={showEventModal} onPress={chooseEventOption} />
        <View style={CommonStyles.flex1}>
          <View style={styles.wrapperImage}>
            <Image style={styles.image} source={{ uri: changeCdnUrl(tripSelected.ImageURL) }} />
            <LinearGradient
              colors={['rgba(0,0,0,.6)', Color.transparent]}
              style={styles.linearGradient}
            ></LinearGradient>
          </View>
          <TripName
            id={receiptResponse.TripId}
            label={tripSelected.TripName}
            editable={userTypes.VISITOR !== type}
          />
          <CircleSegmentedControl
            items={options}
            style={styles.circleSegmented}
            onChange={setSelectedTab}
            selected={selectedTab}
          />
          <TripHubContent
            selectedTab={selectedTab}
            userType={type}
            groupUsers={groupUsers}
            data={data}
          />
        </View>
      </View>
      <BottomSheet
        ref={(ref) => (invoicePanelRef.current = ref)}
        wrapperStyle={bottomWrapperStyle}
        lineStyle={bottomSheetLineStyle}
        sliderMaxHeight={availableHeight}
        sliderMinHeight={0}
        isOpen={route.params.showInvoiceFirst ? true : false}
        onClose={() => setShowInvoice(false)}
        onOpen={() => setShowInvoice(true)}
      >
        <ScrollView style={[CommonStyles.flex1, { minHeight: availableHeight }]}>
          <InvoiceSummary />
        </ScrollView>
      </BottomSheet>
      {selectedTab === tabs.GROUP && type !== userTypes.VISITOR && groupUsers.length > 0 ? (
        <ChatInput
          onSubmit={(message) => {
            setData([
              {
                id: message,
                title: message,
                self: true,
              },
              ...data,
            ]);
          }}
        />
      ) : selectedTab !== tabs.GROUP && !CREW_ENABLED ? (
        <BottomButton
          disabled={selectedTab === tabs.GROUP}
          label={showInvoice ? t(tKey('ViewTripHub')) : t(tKey(labelByUsers[type][selectedTab]))}
          full
          onPress={onSubmit}
        />
      ) : null}
      {selectedTab === tabs.EVENT ? (
        <FloatButton
          style={styles.floatButton}
          iconStyle={styles.floatButtonIcon}
          onPress={onClickFloat}
          iconName={floatIcon}
        />
      ) : null}
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.background,
  },
  image: {
    width: '100%',
    height: '70%',
  },
  linearGradient: {
    position: 'absolute',
    width: '100%',
    height: '70%',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  wrapperImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    zIndex: 0,
  },
  circleSegmented: {
    marginBottom: -6,
    zIndex: 1,
  },
  floatButton: {
    backgroundColor: Color.primary,
  },
  floatButtonIcon: {
    color: Color.accent,
  },
});

export default TripHubScreen;
